
// Getter Object for LabelsCatalog. Use it by calling mapGetters from the Vuex Host Components.

export const labelsCatalogGetters = {
  labelsCatalogData: (state) => state.labelsCatalogData,
  labelList: (state) => state.labelList,
  label_list_start_from: (state) => state.label_list_start_from,
  labelDetails: (state) => state.labelDetails,
}


